<template>
	<DesktopShell>
		<slot />
	</DesktopShell>
</template>

<script setup>
import DesktopShell from "~/components/layout-shell/DesktopShell.vue";
</script>
